// Internal modules
import { $logger, fetchContentAndMetadata, updateLocale } from '@/lib';
import {
  queryCookieBanner,
  removeCookieBanner,
  setCookieBanner,
} from '../../shared';

const handleLanguageChange = language => {
  $logger.fpti('weasley_language_changed', {
    change_to_lang: language,
    state_name: 'signup',
    transition_name: 'language_change',
  });

  removeCookieBanner();
  updateLocale({ language });
  fetchContentAndMetadata();
  queryCookieBanner().then(setCookieBanner);
};

export { handleLanguageChange };
